import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const getDefaultState = () => {
	return {
		contactId: ""
	}
}

const state = getDefaultState()

const getters = {
	GET_CONTACTID: (state) => {
		return state.contactId
	}
}

const mutations = {
	SET_CONTACTID (state, id) {
		state.contactId = id
	},
	resetState (state) {
		Object.assign(state, getDefaultState())
	}
}

const actions = {
	resetModuleState ({ commit }) {
		commit('resetState')
	},
}

export default ({
	namespaced: true,
	state: state,
	mutations: mutations,
	getters: getters,
	actions: actions
})